export default "__VITE_ASSET__BqJ6_6IR__"